<template>
  <v-btn
    :class="['asc-link-button', disabled ? 'asc-link-button--disabled' : null]"
    text
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <asc-label
      :class="[
        'asc-link-button--label',
        {
          'asc-link-button--label-hover': hover,
          'asc-link-button--label-uppercase': uppercase,
        },
      ]"
      :value="text"
      :uppercase="uppercase"
      :prepend-icon="prependIcon"
      :append-icon="appendIcon"
    ></asc-label>
  </v-btn>
</template>

<script>
import AscLabel from './AscLabel'

export default {
  name: 'AscLinkButton',

  components: {
    AscLabel,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: true,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
      default: '',
    },
    appendIcon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.asc-link-button {
  margin: 0;
  padding: 4px 0 0 0 !important;
  height: 18px !important;
  width: auto !important;
  min-width: auto !important;
  background-color: transparent;
  color: transparent !important;
  letter-spacing: 0;

  &--disabled {
    .asc-link-button--label {
      color: $gray-500 !important;
    }
  }

  &::before {
    background-color: $primary-white !important;
  }

  .asc-link-button--label {
    font-size: 13px;
    font-weight: 400;
    color: $accent-700;
    text-transform: none;

    &-uppercase {
      text-transform: uppercase;
    }

    &-hover:hover {
      text-decoration: underline;
    }
  }
}
</style>
